import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { getData, getDataById, addData, updateData, geteventType, getcountries, getReceiptId, getprogramManager, getabReviewers, getabCategoryType, getconferenceEvent, getwebinarEvent } from '../../../services/event/abstractReceipt/abstractReceiptServices';
import { Modal, Button, Form } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import Header from '../../../components/Layout/Header';
import Footer from '../../../components/Layout/Footer';
import Sidebar from '../../../components/Layout/Sidebar';
import Spinner from '../../../components/Spinner';
import Swal from 'sweetalert2';
const subDomain = localStorage.getItem('sub_domain') || '';
 
const AbstractReceipt = () => {
  const [dataList, setDataList] = useState([]);
  const [abstractTitles, setAbstractTitles] = useState([{ title: "" }]);
  const [form, setForm] = useState({
    id: '',
    series: '',
    venue: '',
    abstract_id: '',
    abstract_date: '',
    event_type: '',
    abstract_type: '',
    country: '',
    speaker_name: '',
    email: '',
    conference_committee: '',
    conf_shortname: '',
    coordinator_name: '',
    expertise: '',
    designation: '',
    config_email: '',
    organization: '',
    sub_domain: subDomain,
    abstract_title1: '',
    abstract_title2: '',
    abstract_title3: '',
    reviewer_toggle: false,
    reviewer_id: '',
    reviewer_affiliation: '',
    reviewer_name: '',
    reviewer_country: '',
    reviewer_signature: '',
    event_title: '',
    event_date: '',
    updatedAt: ''
  });
  const [modalType, setModalType] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [errors, setErrors] = useState({});
  const [showInstructionModal, setShowInstructionModal] = useState(false);
 
  // Filter States
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [countryFilter, setCountryFilter] = useState('');
  const [dropdownData, setDropdownData] = useState({
    eventType: [],
    countries: [],
    reviewers: [],
    abcategory: []
  });
 
  const navigate = useNavigate();
 
  const fetchDropdownData = useCallback(async () => {
    try {
      const [event, country, abcategory] = await Promise.all([geteventType(), getcountries(), getabCategoryType()]);
      setDropdownData(prev => ({ ...prev, eventType: event, countries: country, abcategory: abcategory }));
    } catch (error) {
      console.error('Error fetching dropdown data:', error);
    }
  }, []);
 
  const fetchData = useCallback(async () => {
    try {
      const data = await getData({sub_domain: subDomain });
      setDataList(data);
    } catch (error) {
      console.error('Failed to fetch data:', error);
    }
  }, []);
 
  const fetchProgramManager = useCallback(async () => {
    try {
      const data = await getprogramManager({ sub_domain: subDomain });
      if (data && data.length > 0) {
        const programManager = data[0];
 
 
        setForm(prev => ({
          ...prev,
          conference_committee: programManager.conference_committee || '',
          conf_shortname: programManager.conf_shortname || '',
          expertise: programManager.expertise || '',
          coordinator_name: programManager.coordinator_name || '',
          designation: programManager.designation || '',
          config_email: programManager.config_email || ''
        }));
      }
    } catch (error) {
      console.error('Failed to fetch program manager:', error);
    }
  }, []);
 
  const fetchabReviewers = useCallback(async () => {
    try {
      const data = await getabReviewers({ sub_domain: subDomain, approval: true });
      setDropdownData(prev => ({ ...prev, reviewers: data }));
    } catch (error) {
      console.error('Failed to fetch reviewers:', error);
    }
  }, []);

  useEffect(() => {
      const fetchDataAsync = async () => {
          setLoading(true); 
          await fetchData();
          await fetchDropdownData();
          await fetchProgramManager(); 
          await fetchabReviewers();   
          // Optional 2 second delay
          await new Promise((resolve) => setTimeout(resolve, 1000));
          setLoading(false); 
        };
      
        fetchDataAsync();
  }, [fetchData, fetchDropdownData, fetchProgramManager, fetchabReviewers]);
 
  const handleChange = async (e) => {
  const { name, value } = e.target;
  setForm((prev) => ({ ...prev, [name]: value }));
  // Clear error when user types
  setErrors((prev) => ({ ...prev, [name]: '' }));
 
  // Handle event_type-specific logic
  if (name === 'event_type') {
    let eventData = [];
    try {
      if (value.toLowerCase() === 'conference') {
        eventData = await getconferenceEvent({ sub_domain: subDomain });
      } else if (value.toLowerCase() === 'webinar') {
        eventData = await getwebinarEvent({ sub_domain: subDomain });
      }
 
      if (eventData.length > 0) {
        const event = eventData[0]; // Assume first result
        const eventDate = formatEventDate(
          event.from_date,
          event.to_date,
          value.toLowerCase() === 'conference' ? event.venue : ''
        );
 
        setForm((prev) => ({
          ...prev,
          event_title: event.event_title,
          event_date: eventDate,
          series: event.series,
          venue: value.toLowerCase() === 'conference' ? event.venue || '' : 'NIL'
        }));
      }
    } catch (error) {
      console.error('Error loading event details:', error);
    }
  }
};
 
 
  //event title and date and venue
  const formatEventDate = (fromDate, toDate, venue = '') => {
  const from = new Date(fromDate);
  const to = new Date(toDate);
 
  const options = { month: 'long', day: '2-digit' };
  const fromFormatted = from.toLocaleDateString('en-US', options);
  const toFormatted = to.toLocaleDateString('en-US', { day: '2-digit' });
 
  const year = from.getFullYear();
  const range = `${fromFormatted}-${toFormatted}, ${year}`;
  return venue ? `${range}` : range;
};
 
  const handleTitleChange = (index, value) => {
    const list = [...abstractTitles];
    list[index] = { ...list[index], title: value };
    setAbstractTitles(list);
   
    setForm(prev => ({
      ...prev,
      [`abstract_title${index + 1}`]: value
    }));
    setErrors((prev) => ({ ...prev, [value]: '' }));
 
  };
 
  const handleAddTitle = () => {
    if (abstractTitles.length < 3) {
      setAbstractTitles([...abstractTitles, { title: "" }]);
    }
  };
 
  const handleRemoveTitle = (index) => {
    if (abstractTitles.length > 1) {
      const list = [...abstractTitles];
      list.splice(index, 1);
      setAbstractTitles(list);
     
      setForm(prev => {
        const updatedForm = { ...prev };
        updatedForm[`abstract_title${index + 1}`] = '';
        return updatedForm;
      });
    }
  };
 
  const handleReviewerChange = (e) => {
    const { name, value } = e.target;
   
    if (name === "reviewer_id") {
      const selectedReviewer = dropdownData.reviewers.find(reviewer => reviewer.reviewer_id.toString() === value);
      setForm(prev => ({
        ...prev,
        reviewer_name: selectedReviewer ? selectedReviewer.reviewer_name : '',
        reviewer_country: selectedReviewer ? selectedReviewer.reviewer_country : '',
        reviewer_affiliation: selectedReviewer ? selectedReviewer.reviewer_affiliation : '',
        reviewer_signature: selectedReviewer ? selectedReviewer.reviewer_signature : '',
 
        [name]: value
      }));
    } else {
      setForm(prev => ({ ...prev, [name]: value }));
    }
  };
 
  const handleReviewerToggle = (e) => {
    const isChecked = e.target.checked;
    setForm(prev => ({
      ...prev,
      reviewer_toggle: isChecked ? true : false,
      reviewer_id: isChecked ? prev.reviewer_id : '',
      reviewer_country: isChecked ? prev.reviewer_country : '',
      reviewer_name: isChecked ? prev.reviewer_name : '',
      reviewer_affiliation: isChecked ? prev.reviewer_affiliation : '',
      reviewer_signature: isChecked ? prev.reviewer_signature : '',
    }));
  };
  
  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      'abstract_date',
      'event_type',
      'abstract_type',
      'country',
      'speaker_name',
      'email',
      'event_type',
      'series',
      'venue',
      'abstract_id',
      'abstract_date'
 
    ];
 
    requiredFields.forEach((field) => {
      if (!form[field]?.trim()) {
        newErrors[field] = 'Please fill out this field';
      }
    });
 
    // Email format validation
    if (form.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
      newErrors.email = 'Enter a valid email';
    }
 
    // Abstract title validation
    const hasAtLeastOneTitle = abstractTitles.some((item) => item.title.trim() !== '');
    if (!hasAtLeastOneTitle) {
      newErrors.abstractTitles = 'At least one abstract title is required.';
    }
 
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
 
  const handleSubmit = async () => {
    if (!validateForm()) return;
    setIsLoading(true);
    setError('');

    const programManager = await getprogramManager({ sub_domain: subDomain });
    const pm = programManager[0];

    try {
      const submissionData = {
        ...form,
        // PROGRAM MANAGER FIELDS ALWAYS UPDATED BEFORE SAVING
        conference_committee: pm.conference_committee || "",
        conf_shortname: pm.conf_shortname || "",
        expertise: pm.expertise || "",
        coordinator_name: pm.coordinator_name || "",
        designation: pm.designation || "",
        config_email: pm.config_email || "",

        // ABSTRACT TITLES
        abstract_title1: abstractTitles[0]?.title || '',
        abstract_title2: abstractTitles[1]?.title || '',
        abstract_title3: abstractTitles[2]?.title || '',

        // REVIEWER CONDITIONAL FIELDS
        reviewer_id: form.reviewer_toggle === true ? form.reviewer_id : '',
        reviewer_country: form.reviewer_toggle === true ? form.reviewer_country : '',
        reviewer_affiliation: form.reviewer_toggle === true ? form.reviewer_affiliation : '',
        reviewer_signature: form.reviewer_toggle === true ? form.reviewer_signature : '',
        reviewer_name: form.reviewer_toggle === true ? form.reviewer_name : ''
 
      };
 
      let response;
      if (modalType === 'add') {
        // For new records, create and get the generated ID
        response = await addData(submissionData);
       
        if (!response?.data?.id) {
          throw new Error('Failed to get ID for new record');
        }
       
        // Fetch the complete record with generated ID
        const data = await getDataById({ id: response.data.id });
        navigate('/abstractReceiptPdf', { state: { data } });
       
      } else if (modalType === 'edit') {
        // For edits, update and fetch the updated record
        if (!form.id) {
          throw new Error('Record ID is required for editing');
        }
       
        await updateData(submissionData);
        const data = await getDataById({ id: form.id });
        navigate('/abstractReceiptPdf', { state: { data } });
      }
 
    } catch (error) {
      console.error('Error during form submission:', error);
      setError(error.message || 'Failed to submit form. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };
  const getTodayDate = () => {
   return new Date().toISOString().split('T')[0]; // returns 'YYYY-MM-DD'
  };
 
  const openModal = async (type, row = null) => {
    setModalType(type);
    setError(null);
    setErrors({}); // ✅ Clear previous errors
 
    if (type === 'add') {
      try {
        // 👇 Fetch program manager status on the fly
        const data = await getprogramManager({ sub_domain: subDomain });
         // 🚫 Check if no program manager is found
        if (!data || data.length === 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Program Manager Not Found',
          text: 'No Program Manager details found. Please update the Program Manager details.',
          showCancelButton: true,
          confirmButtonText: 'Update Now',
          cancelButtonText: 'Cancel',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33'
        }).then((result) => {
          if (result.isConfirmed) {
            // Redirect to program manager page
            window.location.href = `/programManager`; // ⬅️ replace baseurl with your actual base URL if needed
          }
        });
        return;
      }
 
        const status = data?.[0]?.status ?? true; // fallback to 1 if undefined
        //Show alert and stop if inactive
        if (status === false) {
          Swal.fire({
            icon: 'warning',
            title: 'Program Manager Inactive',
            text: 'Your Program Manager details are inactive. Please contact the admin.',
            confirmButtonColor: '#3085d6'
          });
          return;
        }
       const todayDate = getTodayDate();
        //Continue with opening modal
        setForm({
          ...form,
          id: '',
          series: '',
          venue: '',
          abstract_id: '',
          abstract_date: todayDate,
          event_type: '',
          abstract_type: '',
          country: '',
          speaker_name: '',
          email: '',
          organization: '',
          abstract_title1: '',
          abstract_title2: '',
          abstract_title3: '',
          reviewer_toggle: false,
          reviewer_id: '',
          reviewer_affiliation: '',
          reviewer_name: '',
          reviewer_country: '',
          reviewer_signature: ''
        });
 
        setAbstractTitles([{ title: '' }]);
 
        const result = await getReceiptId({ sub_domain: subDomain, type: 'abstract' });
        if (result?.abstract_id) {
          setForm(prev => ({ ...prev, abstract_id: result.abstract_id }));
        }
 
      } catch (error) {
        console.error("Error checking status or fetching initial data:", error);
      }
    }
 
    if (type === 'edit' && row) {
      setForm({
        ...row,
        reviewer_toggle: row.reviewer_toggle || false,
        reviewer_id: row.reviewer_id || '',
        reviewer_country: row.reviewer_country || '',
        reviewer_affiliation: row.reviewer_affiliation || '',
        reviewer_signature: row.reviewer_signature || '',
        reviewer_name: row.reviewer_name || ''
      });
 
      const titles = [];
      if (row.abstract_title1) titles.push({ title: row.abstract_title1 });
      if (row.abstract_title2) titles.push({ title: row.abstract_title2 });
      if (row.abstract_title3) titles.push({ title: row.abstract_title3 });
      setAbstractTitles(titles.length > 0 ? titles : [{ title: '' }]);
    }
 
    setShowModal(true);
  };
 
  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };
 
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
 
  //based country code append country name
  const getCountryName = (code) => {
  const country = dropdownData.countries.find(c => c.code === code);
  return country ? country.name : code;
  };
 
  const filteredData = useMemo(() => {
    const startDateObj = startDate ? new Date(startDate) : null;
    const endDateObj = endDate ? new Date(endDate) : null;
 
    return dataList
      .filter((data) => {
        // Text search (case insensitive)
        const matchesText =
          data.speaker_name?.toLowerCase().includes(searchText.toLowerCase()) ||
          data.abstract_id?.toLowerCase().includes(searchText.toLowerCase()) ||
          data.country?.toLowerCase().includes(searchText.toLowerCase());
 
        // Convert abstract_date to Date for comparison
        const date = data.abstract_date ? new Date(data.abstract_date) : null;
 
        // Date range filtering
        const inRange = (startDateObj && endDateObj)
          ? date >= startDateObj && date <= endDateObj
          : true;
 
        // Country filtering
        const matchCountry = !countryFilter || data.country === countryFilter;
 
        return matchesText && inRange && matchCountry;
      }).sort((a, b) => new Date(b.abstract_date) - new Date(a.abstract_date));
  }, [dataList, searchText, startDate, endDate, countryFilter]);
 
  const columns = [
    {
      name: '#',
      selector: (row, index) => (currentPage - 1) * 10 + (index + 1),
      sortable: false,
      width: '60px',
    },
    {
      name: 'Abstract Date',
      selector: (row) => row.abstract_date,
      sortable: true,
      wrap: true,
    },
    {
      name: 'Speaker Name',
      selector: (row) => row.speaker_name,
      sortable: true,
      wrap: true,
    },
   
    {
      name: 'Country',
      selector: (row) => getCountryName(row.country),
      sortable: true,
      wrap: true,
    },
    {
      name: 'Actions',
      cell: (row) => (
        <div>
          <Button className="me-2" variant="warning" size="sm" onClick={() => openModal('edit', row)}>
            Edit
          </Button>
        </div>
      ),
    },
  ];
 
  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        {loading ? (
            <div className="d-flex justify-content-center align-items-center w-100" style={{ minHeight: "300px" }}>
              <Spinner /> {/* Centered Spinner */}
            </div>
            ) :(
          <div>
         <div className=" row m-3 d-flex flex-column gap-3 ">
          <div className="d-flex gap-2">
            {/* Dropdown for Filters */}
            <div className="col-md-2">
            <span className='fs-5 text-dark'>Countries</span>
            <select
              className="form-control"
              value={countryFilter}
              onChange={(e) => setCountryFilter(e.target.value)}
            >
              <option value="">All Countries</option>
              {dropdownData.countries.map((country) => (
                <option key={country.code} value={country.code}>
                  {country.name}
                </option>
              ))}
            </select>
          </div>
 
            {/* Start Date and End Date Input */}
            <div className="col-md-2">
              <span className='fs-5 text-dark'>Start Date</span>
              <input
                type="date"
                className="form-control"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>
            <div className="col-md-2">
              <span className='fs-5 text-dark'>End Date</span>
              <input
                type="date"
                className="form-control"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>
          </div>
 
       
        </div>
 
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col-8">
              <p className='fs-4 text-dark'>Receipt Generation / Abstract Receipt</p>
            </div>
            <div className="col-4 text-end">
              <button className="btn btn-primary mb-3" onClick={() => openModal('add')}>
                Add
              </button>
            </div>
          </div>
 
          {error && (
            <div className="alert alert-danger">
              {error}
            </div>
          )}
 
          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            highlightOnHover
            responsive
            striped
            paginationPerPage={10}
            paginationRowsPerPageOptions={[10, 20, 50, 100, 200, 500]}
            onChangePage={handlePageChange}
            subHeader
            subHeaderComponent={
              <div>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Search"
                  value={searchText}
                  onChange={handleSearchChange}
                />
              </div>
            }
          />
 
          <Modal show={showModal} backdrop="static" className='modal-xl' onHide={() => setShowModal(false)}>
            <Modal.Header closeButton>
              <Modal.Title className='fs-4'>{modalType === 'add' ? 'Add Abstract Receipt' : 'Edit Abstract Receipt'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {error && (
                <div className="alert alert-danger">
                  {error}
                </div>
              )}
              <Form>
                <div className='row'>
                <Form.Group className="col-md-3 mb-3">
                    <Form.Label className='fs-5 text-dark'>Abstract ID<small className="text-danger fs-5"> * </small></Form.Label>
                    <Form.Control type="text" name="abstract_id" value={form.abstract_id} readOnly />
                  </Form.Group>
                   <Form.Group className="col-md-3 mb-3">
                    <Form.Label className='fs-5 text-dark'>Event Type<small className="text-danger fs-5"> *</small></Form.Label>
                    <Form.Select name="event_type" value={form.event_type} onChange={handleChange} isInvalid={!!errors.event_type}>
                      <option value="">Select</option>
                      {dropdownData.eventType.map((eventType) => (
                        <option key={eventType.type} value={eventType.type}>
                          {eventType.type}
                        </option>
                      ))}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">  {errors.event_type} </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group className="col-md-3 mb-3">
                    <Form.Label className='fs-5 text-dark'>Series<small className="text-danger fs-5"> * </small></Form.Label>
                    <Form.Control type="text" name="series" value={form.series} readOnly />
                  </Form.Group>
                  <Form.Group className="col-md-3 mb-3">
                    <Form.Label className='fs-5 text-dark'>Venue<small className="text-danger fs-5"> * </small></Form.Label>
                    <Form.Control type="text" name="venue" value={form.venue} readOnly />
                  </Form.Group>
                  <Form.Group className="col-md-4 mb-3">
                    <Form.Label className='fs-5 text-dark'>Abstract Date<small className="text-danger fs-5"> * </small></Form.Label>
                    <Form.Control type="date" name="abstract_date" value={form.abstract_date} onChange={handleChange} isInvalid={!!errors.abstract_date}/>
                    <Form.Control.Feedback type="invalid">  {errors.abstract_date} </Form.Control.Feedback>
                  </Form.Group>
                 
                  <Form.Group className="col-md-4 mb-3">
                    <Form.Label className='fs-5 text-dark'>Abstract Category<small className="text-danger fs-5"> * </small></Form.Label>
                    <Form.Select name="abstract_type" value={form.abstract_type} onChange={handleChange} isInvalid={!!errors.abstract_type}>
                      <option value="">Select</option>
                      {dropdownData.abcategory.map((abcategory) => (
                        <option key={abcategory.category} value={abcategory.type}>
                          {abcategory.category}
                        </option>
                      ))}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">  {errors.abstract_type} </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group className="col-md-4 mb-3">
                    <Form.Label className='fs-5 text-dark'>Country<small className="text-danger fs-5"> * </small></Form.Label>
                    <Form.Select name="country" value={form.country} onChange={handleChange} isInvalid={!!errors.country}>
                      <option value="">Select</option>
                      {dropdownData.countries.map((country) => (
                        <option key={country.code} value={country.code}>
                          {country.name}
                        </option>
                      ))}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">  {errors.country} </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group className="col-md-3 mb-3">
                    <Form.Label className='fs-5 text-dark'>Speaker Name<small className="text-danger fs-5"> * </small></Form.Label>
                    <Form.Control type="text" name="speaker_name" value={form.speaker_name} onChange={handleChange} isInvalid={!!errors.speaker_name}/>
                    <Form.Control.Feedback type="invalid">  {errors.speaker_name} </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group className="col-md-3 mb-3">
                    <Form.Label className='fs-5 text-dark'>Email<small className="text-danger fs-5"> * </small></Form.Label>
                    <Form.Control type="email" name="email" value={form.email} onChange={handleChange} isInvalid={!!errors.email}/>
                    <Form.Control.Feedback type="invalid">  {errors.email} </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group className="col-md-6 mb-3">
                    <Form.Label className='fs-5 text-dark'>Affiliation</Form.Label>
                    <Form.Control type="text" name="organization" value={form.organization} onChange={handleChange} isInvalid={!!errors.organization}/>
                    <Form.Control.Feedback type="invalid">  {errors.organization} </Form.Control.Feedback>
                  </Form.Group>
 
                  <div className="col-md-12 mb-3">
                      {abstractTitles.map((item, index) => (
                        <div key={index} className="mb-3">
                          <Form.Label className='fs-5 text-dark'>Abstract Title {index + 1}<small className="text-danger fs-5"> * </small></Form.Label>
                          <div className="input-group">
                            <Form.Control
                              type="text"
                              value={item.title}
                              onChange={(e) => handleTitleChange(index, e.target.value)}
                              isInvalid={!!errors.abstractTitles && item.title.trim() === ''}
                            />
                            <Button
                              variant={index === 0 ? "success" : "danger"}
                              onClick={index === 0 ? handleAddTitle : () => handleRemoveTitle(index)}
                              disabled={index > 0 && abstractTitles.length <= 1}
                            >
                              {index === 0 ? "+" : "-"}
                            </Button>
                          </div>
                        </div>
                      ))}
                      {errors.abstractTitles && (
                        <div className="text-danger mt-1">
                          {errors.abstractTitles}
                        </div>
                      )}
                    </div>
                   
                  <Form.Group className="col-md-12 mb-3">
                    <Form.Check
                      type="switch"
                      id="reviewer-toggle"
                      label="Include Reviewer"
                      checked={form.reviewer_toggle === true}
                      className='fs-4 text-dark'
                      onChange={handleReviewerToggle}
                    />
                  </Form.Group>
 
                  {Boolean(form.reviewer_toggle) === true && (
                    <>
                      <Form.Group className="col-md-6 mb-3">
                        <Form.Label className='fs-5 text-dark'>Reviewer</Form.Label>
                        <Form.Select
                          name="reviewer_id"
                          value={form.reviewer_id}
                          onChange={handleReviewerChange}
                        >
                          <option value="">Select Reviewer</option>
                          {dropdownData.reviewers.map((reviewer) => (
                            <option key={reviewer.reviewer_id} value={reviewer.reviewer_id}>
                              {reviewer.reviewer_name}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>                  
                    </>
                  )}
                </div>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="info" onClick={() => setShowInstructionModal(true)} className="me-auto">
                Instructions
              </Button>
              <Button variant="secondary" onClick={() => setShowModal(false)} disabled={isLoading}>
                Close
              </Button>
              <Button variant="primary" onClick={handleSubmit} disabled={isLoading}>
                {isLoading ? 'Processing...' : modalType === 'add' ? 'Save' : 'Update'}
              </Button>
            </Modal.Footer>
          </Modal>
          <Modal
            show={showInstructionModal}
            onHide={() => setShowInstructionModal(false)}
            size="m"
            top border 
          >
            <Modal.Header closeButton>
              <Modal.Title className='fs-5 text-dark'>Instructions</Modal.Title>
            </Modal.Header>
 
            <Modal.Body>
              <div className="table-responsive">
              <table className="table table-bordered table-striped">
                <thead className="table-dark">
                  <tr>
                    <th>#</th>
                    <th>Example</th>
                    <th>Solution</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><b>Superscript</b></td>
                    <td>Monarc<sup><b>R</b></sup></td>
                    <td>Monarc&lt;sup&gt;<b>R</b>&lt;/sup&gt;</td>
                  </tr>
                  <tr>
                    <td><b>Subscript</b></td>
                    <td>CH<sub><b>2</b></sub>O</td>
                    <td>CH&lt;sub&gt;<b>2</b>&lt;/sub&gt;O</td>
                  </tr>
                  <tr>
                    <td><b>Italic</b></td>
                    <td>This is <i><b>italic</b></i> text</td>
                    <td>This is &lt;i&gt;<b>italic</b>&lt;/i&gt; text</td>
                  </tr>
                </tbody>
              </table>
              </div>
            </Modal.Body>
 
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowInstructionModal(false)}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
        <Footer />
      </div>
      )}
      </div>
    </div>
  );
};
 
export default AbstractReceipt;
 